export class CampaignNumber {
    public campaignNumber: string;

    public static empty(): CampaignNumber {
        const campaignNumber: CampaignNumber = new CampaignNumber();
		campaignNumber.campaignNumber = "";
		return campaignNumber;
    }

    public static from(anemicCampaignNumber: CampaignNumber): CampaignNumber {
		if (!anemicCampaignNumber) return undefined;
        const campaignNumber: CampaignNumber = CampaignNumber.empty();
		campaignNumber.campaignNumber = anemicCampaignNumber.campaignNumber;
		return campaignNumber;
	}
}